export const INCLUSION_BANK = [

  {
    id: "inc_01",

    dimension: "inclusion",

    behaviour: "initiating_conversations",

    scenario: "new_class",

    text: "It's your first day in a new class where you don't know anyone. You usually...",

    options: [
      {
        label: "Introduce yourself and start talking to a few classmates",
        weights: { inclusion: +2 }
      },
      {
        label: "Join conversations if someone starts talking to you",
        weights: { inclusion: +1 }
      },
      {
        label: "Wait a while before getting to know people",
        weights: { inclusion: 0 }
      },
      {
        label: "Keep to yourself unless it's necessary to interact",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_02",

    dimension: "inclusion",

    behaviour: "public_participation",

    scenario: "class_discussion",

    text: "During a class discussion, you usually...",

    options: [
      {
        label: "Share your ideas even if they're different from others",
        weights: { inclusion: +2, thinking: +1 }
      },
      {
        label: "Speak when you have something useful to add",
        weights: { inclusion: +1 }
      },
      {
        label: "Prefer listening unless you're asked to contribute",
        weights: { inclusion: 0 }
      },
      {
        label: "Avoid speaking if possible",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_03",

    dimension: "inclusion",

    behaviour: "collaboration",

    scenario: "group_assignment",

    text: "When working on a group assignment, you usually...",

    options: [
      {
        label: "Encourage everyone to share ideas",
        weights: { inclusion: +2, affection: +1 }
      },
      {
        label: "Contribute throughout the discussion",
        weights: { inclusion: +1 }
      },
      {
        label: "Focus mainly on completing your own part",
        weights: { inclusion: 0, control: +1 }
      },
      {
        label: "Prefer to work on your own whenever possible",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_04",

    dimension: "inclusion",

    behaviour: "seeking_support",

    scenario: "difficult_lesson",

    text: "You're finding a lesson difficult to understand. You usually...",

    options: [
      {
        label: "Ask questions until you understand it",
        weights: { inclusion: +2, thinking: +1 }
      },
      {
        label: "Ask a classmate or teacher for help later",
        weights: { inclusion: +1 }
      },
      {
        label: "Try to work it out by yourself first",
        weights: { inclusion: 0, thinking: +1 }
      },
      {
        label: "Keep quiet even if you don't understand",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_05",

    dimension: "inclusion",

    behaviour: "community_engagement",

    scenario: "school_activity",

    text: "Your school is organising an activity that interests you. You usually...",

    options: [
      {
        label: "Join and take an active part",
        weights: { inclusion: +2 }
      },
      {
        label: "Join if your friends are participating",
        weights: { inclusion: +1 }
      },
      {
        label: "Watch but don't get involved",
        weights: { inclusion: 0 }
      },
      {
        label: "Prefer not to participate",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_06",

    dimension: "inclusion",

    behaviour: "meeting_new_people",

    scenario: "school_event",

    text: "At a school programme where you meet students from other schools, you usually...",

    options: [
      {
        label: "Start conversations and get to know new people",
        weights: { inclusion: +2 }
      },
      {
        label: "Talk to people if the opportunity comes up",
        weights: { inclusion: +1 }
      },
      {
        label: "Stay mostly with people you already know",
        weights: { inclusion: 0 }
      },
      {
        label: "Avoid interacting unless necessary",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_07",

    dimension: "inclusion",

    behaviour: "encouraging_participation",

    scenario: "quiet_teammate",

    text: "During group work, one teammate hasn't said anything. You usually...",

    options: [
      {
        label: "Invite them to share their ideas",
        weights: { inclusion: +2, affection: +1 }
      },
      {
        label: "Ask if they have anything to add",
        weights: { inclusion: +1 }
      },
      {
        label: "Wait to see if they choose to speak",
        weights: { inclusion: 0 }
      },
      {
        label: "Continue without involving them",
        weights: { inclusion: -2 }
      }
    ]
  },

  {
    id: "inc_08",

    dimension: "inclusion",

    behaviour: "relationship_building",

    scenario: "new_term",

    text: "A new student joins your class during the term. You usually...",

    options: [
      {
        label: "Welcome them and help them settle in",
        weights: { inclusion: +2 }
      },
      {
        label: "Talk to them if you get the chance",
        weights: { inclusion: +1 }
      },
      {
        label: "Wait for them to approach you first",
        weights: { inclusion: 0 }
      },
      {
        label: "Keep to yourself unless necessary",
        weights: { inclusion: -2 }
      }
    ]
  },

];